import React, { useContext } from 'react';

export const UserContext = React.createContext({
  user: null,
  setUser: () => {},
});

export const useUser = () => {
  const { user, setUser } = useContext(UserContext);
  return { user, setUser };
};
